import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitString'
})
export class LimitStringPipe implements PipeTransform {

  transform(value: string, stringLimit: number): any {
    // console.log(stringLimit);
    if(value.length > stringLimit) value = value.substring(0,stringLimit);
    return value;
  }
}